import {AuthApiService} from "@/services/api/api.auth.js";
import {DCLApiService} from "@/services/api/api.dcl.js";
import {FrServerApiService} from "@/services/api/api.fr.js";
import {UsersApiService} from "@/services/api/api.users.js";
import {OptionsApiService} from "@/services/api/api.options.js";

const resource =  {
  AUTH: "auth",
  DCL: "dcl",
  FR_SERV: "frserv",
  USERS: "options/users",
  OPT_GENERAL: "options/general"
};

export const createApiMethods = (notifier, callback) => {
  return {
    auth : new AuthApiService (resource.AUTH, notifier, callback),
    dcl: new DCLApiService(resource.DCL, notifier, callback),
    frserv : new FrServerApiService (resource.FR_SERV, notifier, callback),
    users : new UsersApiService (resource.USERS, notifier, callback),
    optgeneral : new OptionsApiService (resource.OPT_GENERAL, notifier, callback),
    // "UPDATE_DT": CrudApiService(notifier),
  }
}